import { Stack, FormLabel, Typography, Grid } from "@mui/material"

const CardStat = ({ label, value, tall }) => {
  return (
    <Grid item xs={6} sm>
      <Stack gap={1}>
        <FormLabel sx={{ fontSize: 14, height: tall ? "2.5rem" : "auto" }}>
          {label}
        </FormLabel>
        <Typography fontWeight={700}>{value || "-"}</Typography>
      </Stack>
    </Grid>
  )
}

export { CardStat }
